'use strict';

import axios from 'axios';
import getHeader from '../config/header';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Email = {

    async contact(email, name, message, ipAddress) {
		try {
            let header = getHeader();

            let response = await axios.post(API_URL +  '/contact/antonishg', {
                email: email,
                name: name, 
                message: message,
                originIP: ipAddress
            }, header);
            
			return response.data.ip;

		} catch(error) {
            return false;
		}
	}
    
}

export default Email;